(() => {
  if (window.__zyraYampiQuantitySyncInstalled) return;
  window.__zyraYampiQuantitySyncInstalled = true;

  const findBlock = (element) => {
    if (!(element instanceof Element)) return null;
    return element.closest('.buy-buttons-block');
  };

  const syncQuantity = (block) => {
    if (!block) return;
    const shopifyInput = block.querySelector('product-form-component form input[name="quantity"]');
    const yampiInput = block.querySelector('.zyra-yampi-buy-button .ymp-input');
    if (!shopifyInput || !yampiInput) return;

    const minValue = Number.parseInt(shopifyInput.getAttribute('min') || '1', 10);
    const maxAttribute = shopifyInput.getAttribute('max');
    const maxValue = maxAttribute ? Number.parseInt(maxAttribute, 10) : null;
    let quantity = Number.parseInt(shopifyInput.value, 10);

    if (!Number.isFinite(quantity) || quantity < minValue) quantity = minValue;
    if (Number.isFinite(maxValue)) quantity = Math.min(quantity, maxValue);

    yampiInput.value = String(quantity);
  };

  const syncAll = () => {
    document.querySelectorAll('.buy-buttons-block > .zyra-yampi-buy-button').forEach((wrapper) => {
      syncQuantity(wrapper.closest('.buy-buttons-block'));
    });
  };

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.name === 'quantity') {
      syncQuantity(findBlock(target));
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.name === 'quantity') {
      syncQuantity(findBlock(target));
    }
  });

  document.addEventListener('focusout', (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.name === 'quantity') {
      const block = findBlock(target);
      queueMicrotask(() => syncQuantity(block));
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const quantityButton = target.closest('.buy-buttons-block product-form-component .quantity-selector-component .quantity-plus, .buy-buttons-block product-form-component .quantity-selector-component .quantity-minus');
    if (quantityButton) {
      const block = findBlock(quantityButton);
      queueMicrotask(() => syncQuantity(block));
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const buyButton = target.closest('.buy-buttons-block .ymp-buy-button');
    if (buyButton) syncQuantity(findBlock(buyButton));
  }, true);

  const observer = new MutationObserver((records) => {
    const yampiMounted = records.some((record) => Array.from(record.addedNodes).some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches('.ymp-buy-button-holder, .ymp-input, .zyra-yampi-buy-button') ||
        Boolean(node.querySelector('.ymp-buy-button-holder'));
    }));
    if (yampiMounted) queueMicrotask(syncAll);
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();